import script from "./CustomerView.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerView.vue?vue&type=script&setup=true&lang=js"

import "./CustomerView.vue?vue&type=style&index=0&id=4c0749ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c0749ae"]])

export default __exports__